module.exports = __webpack_public_path__ + "static/media/arrow.c7815a50.svg";